/* @flow */

import {
    STATUS_PENDENTE,
    STATUS_PAGO,
    STATUS_CANCELADO,
    STATUS_EXPIRADO,
    STATUS_DEVOLVIDA,
    STATUS_AUTORIZADA,
    STATUS_EM_DISPUTA,
    STATUS_PARCIALMENTE_PAGA,
    STATUS_CHARGEBACK,
} from './constants';

const stateColorsStatusIugu = (status: String) => {
    switch (status) {
    case STATUS_PENDENTE: return 'brand';
    case STATUS_PAGO: return 'success';
    case STATUS_CANCELADO: return 'danger';
    case STATUS_EXPIRADO: return 'danger';
    case STATUS_DEVOLVIDA: return 'warning';
    case STATUS_AUTORIZADA: return 'success';
    case STATUS_EM_DISPUTA: return 'warning';
    case STATUS_PARCIALMENTE_PAGA: return 'brand';
    case STATUS_CHARGEBACK: return 'warning';
    default: return 'light';
    }
};

export default stateColorsStatusIugu;
